import {Component, inject} from '@angular/core';
import {HeaderService} from "../header/services/header.service";
import {fade, slideInLeft} from "../../common/animations/animations";

@Component({
  selector: 'app-side-menu',
  standalone: true,
  imports: [],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
  animations:[slideInLeft, fade]
})
export class SideMenuComponent {

  private headerService = inject(HeaderService);

  close() {
    this.headerService.setMenuToggleActive();
  }
}
